import { FC } from "react";
import { GoalType, MatchEvent, MatchEventShort, MathcEventType } from "../../types/fixtures/match";
import { Ball, DownArrow, getIconByGoalType, GoalKeeper, UpArrow, YellowCard } from "./MatchIcons";
import { Link } from "../../components";

interface PlayerEventProps {
    eventType: string;
    time: string;
}

const PlayerEvent: FC<PlayerEventProps> = ({
    eventType,
    time,
}) => {
    let icon = null;
    switch (eventType) {
        case MathcEventType.Goal:
            icon = <Ball />
            break;
        case MathcEventType.YellowCard:
            //icon = <span className="text-yellow-400 "><YellowCard /></span>
            icon = <div className="bg-yellow-400 rounded w-4 h-5" />
            break;
        case MathcEventType.RedCard:
            //icon = '🟥';
            icon = <div className="bg-red-600 rounded w-4 h-6" />
            break;
        case MathcEventType.SubstitutionIn:
            icon = <span className="text-green-600"><UpArrow /></span>;
            break;
        case MathcEventType.SubstitutionOut:
            icon = <span className="text-red-600"><DownArrow /></span>;
            break;
        case MathcEventType.PenaltyGoal:
            icon = getIconByGoalType(GoalType.Penalty)
            break;
        case MathcEventType.AutoGoal:
            icon = getIconByGoalType(GoalType.Auto)
            break;
        case MathcEventType.MissedPenalty:
            icon = getIconByGoalType(GoalType.MissedPenalty)
            break;
    }

    return (
        <div className="flex flex-row gap-1 items-center">
            {icon} {time}
        </div>
    );
}

interface PlayerItemProps {
    name: string;
    isGK?: boolean;
    isCaptain?: boolean;
    events?: MatchEventShort[];
    url?: string;
    align?: 'left' | 'right';
}

export const PlayerItem: FC<PlayerItemProps> = ({
    name,
    isGK,
    isCaptain,
    events,
    url,
    align,
}) => {
    let containerClasses = "flex flex-col text-xl gap-1 sm:text-3xl sm:p-4 bg-gray-100/00 w-full rounded-3xl h-20";
    if (url) {
        containerClasses += " cursor-pointer transition-all hover:text-sky-500";
    }

    if (align === 'right') {
        containerClasses += ' items-end text-right';
    }

    let nameClasses = '';

    if (name.length > 15) {
        if (isGK || isCaptain || name.length > 17) {
            nameClasses += ' text-lg sm:text-3xl';
        }
    }

    return (
        <div className={containerClasses}>
            <div className="flex flex-row gap-1 items-start sm:items-center">
                {!url && <div className={nameClasses}>{name}</div>}
                {url && <Link to={url} className={nameClasses}>{name}</Link>}
                {isGK && <div><GoalKeeper /></div>}
                {isCaptain && <span className="font-semibold text-yellow-500">К</span>}
            </div>
            <div className="flex flex-row gap-2 items-center text-base sm:text-2xl">
                {events && events.map((event, index) => (
                    <PlayerEvent
                        key={index}
                        eventType={event.eventType}
                        time={`${event.time}'`}
                    />
                ))}
            </div>
        </div>
    );
}

interface PlayersListProps {
    players: PlayerItemProps[];
    align?: 'right' | 'left'
}

export const PlayersList: FC<PlayersListProps> = ({
    players,
    align = 'left'
}) => {
    let className = "sm:min-w-96 w-1/2 flex flex-col gap-2 sm:gap-4 items-center";

    return (
        <div className={className}>
            {players.map((player, index) => {
                player.events.sort((a, b) => a.time - b.time);
                return <PlayerItem key={index} {...player} align={align} />
            })}
        </div>
    );
}
